import { Button, CircularProgress, Typography } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';

import useProductList from 'core/hooks/useProductList';
import currency from 'Elements/Formats/currency';
import {
  Body,
  Column,
  GridTable,
  Header,
  Row as GridRow,
} from 'Elements/GridTable';
import LinkRow from 'Elements/GridTable/LinkRow';

const Row = styled(GridRow)`
  grid-template-columns: 70px minmax(150px, 1fr) 100px 100px;
`;

const CenterColumn = styled(Column)`
  grid-column: 1 / 6;
  display: flex;
  justify-content: center;
`;

type Props = {
  params: any;
};

export default function ProductsTable({ params }: Props) {
  const { data: products, loading, hasMore, loadMore } = useProductList(params);

  return (
    <GridTable>
      <Header>
        <Row>
          <Column>Koodi</Column>
          <Column>Nimi</Column>
          <Column>Ura</Column>
          <Column>Hinta</Column>
        </Row>
      </Header>

      <Body>
        {products.map(product => (
          <LinkRow to={'/products/' + product.id} key={product.id}>
            <Row hover>
              <Column>{product.code}</Column>
              <Column>{product.name}</Column>
              <Column>{product.track_depth}</Column>
              <Column>{currency.format(product.price)}</Column>
            </Row>
          </LinkRow>
        ))}
        <Row>
          <CenterColumn>
            {loading && <CircularProgress />}

            {!loading && hasMore && (
              <Button variant="contained" color="primary" onClick={loadMore}>
                Lataa lisää
              </Button>
            )}

            {!loading && !hasMore && (
              <Typography variant="subtitle1">Ei enempää tuotteita</Typography>
            )}
          </CenterColumn>
        </Row>
      </Body>
    </GridTable>
  );
}
